
<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" class="close-button" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<h1 style="font-weight: bold;">{{ Asset.SerialId}}</h1>
<mat-dialog-content>

  <h2>{{'T4.Service.AssetInformationDialog.GeneralDetails' | translate : 'General details' }}</h2>

  <t4-container>

    <div *ngIf="Lock?.BatteryLevel && Lock?.BluetoothMAC && Asset.SerialId" style="margin-bottom:10px;">
      <mat-icon matSuffix title="{{'T4.Service.AssetInformationDialog.Lock' | translate : 'Lock' }}">lock</mat-icon>
      <mat-icon *ngIf="Asset?.Condition == 0" title="{{'T4.Service.AssetInformationDialog.Repairable' | translate : 'Repairable' }}" style="position: absolute; right: 20px;" matSuffix>handyman</mat-icon>
      <mat-icon *ngIf="Asset?.Scrapped" title="{{'T4.Service.AssetInformationDialog.Scrapted' | translate : 'Scrapted' }}" style=" position: absolute; right: 10px;">delete_forever</mat-icon>
      <mat-icon *ngIf="Asset?.CurrentHolder == 'Stolen'" title="{{'T4.Service.AssetInformationDialog.Missing' | translate : 'Missing' }}" style=" position: absolute; right: 10px;">warning</mat-icon>
    </div>


    <div>
      <div class="row align-items-end">
        <div class="col">
          
          <div>
            <label style="margin-right:4px;">{{ 'T4.Service.AssetInformationDialog.txtType' | translate : 'Type'}}:</label>
            <span>{{ Lock?.Type }}</span>
          </div>
          
          <div>
            <label style="margin-right:4px;">{{ 'T4.Service.AssetInformationDialog.txtIccId' | translate : 'IccId' }}:</label>
            <span>{{ Lock?.IccId}}</span>
          </div>
          <div *ngIf="Lock?.BluetoothMAC != Lock?.Mac">
            <label style="margin-right:4px;">{{ 'T4.Service.AssetInformationDialog.txtBluetoothMAC' | translate : 'Bluetooth MAC' }}:</label>
            <span>{{ Lock?.BluetoothMAC || Asset.Mac}}</span>
          </div>
          <div>
            <label style="margin-right:4px;">{{ 'T4.Service.AssetInformationDialog.txtMacAdress' | translate : 'Mac adress'}}:</label>
            <span>{{ Lock?.Mac || Asset.Mac }}</span>
          </div>
        </div>
        <div class="col">
          <div>
            <label style="margin-right:4px;">{{ 'T4.Service.AssetInformationDialog.txtLastUpdate' | translate : 'Last Update' }}:</label>
            <span> {{ Lock?.LastUpdate ? (Lock.LastUpdate | date : 'yyyy-MM-dd hh:mm') : 'No activity yet logged' }}</span>
          </div>
          <div>
            <label style="margin-right:4px;">{{ 'T4.Service.AssetInformationDialog.txtCurrentHolder' | translate : 'Current Holder' }}:</label>
            <span>{{ Asset?.CurrentHolder || 'Unknown'}}</span>
          </div>
          <div *ngIf="Asset?.IsRetired != 0">
            <label style="margin-right:4px;">{{ 'T4.Service.AssetInformationDialog.txtRetired' | translate : 'Retired' }}:</label>
            <span><mat-icon matSuffix title="{{'T4.Service.AssetInformationDialog.RetiredTrue' |translate : 'Retired' }}">done</mat-icon></span>
          </div>
        </div>
        <div class="col-2" style="text-align:center">
          <div>
            <label style="margin-right:4px;">{{ 'T4.Service.AssetInformationDialog.txtBatteryLevel' | translate : 'BatteryLevel'}}</label>
          </div>
          <p>{{ Lock?.BatteryLevel ? (Lock.BatteryLevel + 'mV') : 'Not initialized' }} ({{ (Lock?.BatteryLevel | batteryProcentile).percentage }}%)</p>
          <mat-icon [ngClass]="(Lock?.BatteryLevel | batteryProcentile).class" style="transform: scale(2); rotate: -90deg;">
            {{ (Lock?.BatteryLevel | batteryProcentile).icon }}
          </mat-icon>
        </div>
      </div>
    </div>
    
  </t4-container>
  <br />
  <h2>{{'T4.AssetInformation.assetInformationDialog.lblhistory' |translate : 'History' }}</h2>
  <t4-container style=" max-height: 280px;">

    <mat-tab-group>
      <mat-tab label="{{'T4.Campaigns.tblMovement' | translate : 'Movement' }}">

        <t4-data-table #tblInventoryAssets [allowExcel]="false" [allowPaging]="true" [allowFilter]="false" [rawData]="InventoryAsset" style="max-height: 280px;" headline="{{'T4.AssetInformation.assetInformationDialog.lblAssetHistory' | translate : 'Asset history' }}" matSort matSortActive="ConfirmedDt" matSortDirection="desc" [autoGenerateColumns]="false" [filterFields]="['Status', 'CreatedAt', 'DeletedAt']">

          <ng-container matColumnDef="CreatedAt">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 50px; justify-content: center;">{{'T4.AssetInformation.assetInformationDialog.lblstart' |translate : 'Start' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 50px; justify-content: center;">{{ row.StartTime | date : 'yyyy-MM-dd hh:mm' }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="DeletedAt">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 50px; justify-content: center;">{{'T4.AssetInformation.assetInformationDialog.lblend' |translate : 'End' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 50px; justify-content: center;">{{ row.EndTime | date : 'yyyy-MM-dd hh:mm' }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="SG">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 120px; justify-content: center; ">{{'T4.AssetInformation.assetInformationDialog.lblTypeHolder' | translate : 'Holder type' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 120px; justify-content: center;">{{ row.PositionIsSG ? 'ServiceGuy' : 'Customer' }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="Position">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 250px; justify-content: center;">{{'T4.AssetInformation.assetInformationDialog.lblPosition' |translate : 'Position' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 250px; justify-content: center;"> <t4-location-link [locationId]=row.LocationId>{{ row.Position }}</t4-location-link></mat-cell>
          </ng-container>


          <ng-container matColumnDef="CreatedBy">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 50px; justify-content: center;">{{'T4.AssetInformation.assetInformationDialog.lblCreatedBy' |translate : 'CreatedBy' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 50px; justify-content: center;">{{ row.CreatedBy }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="ClosedBy">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 50px; justify-content: center;">{{'T4.AssetInformation.assetInformationDialog.lblClosedBy' |translate : 'ClosedBy' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 50px; justify-content: center;">{{ row.ClosedBy }}</mat-cell>
          </ng-container>

        </t4-data-table>
      </mat-tab>
      <mat-tab style="max-width: 50px; max-height: 50px;" label="{{'T4.AssetInformation.assetInformationDialog.lblogs' | translate : 'Logs' }}">

        <t4-data-table [allowPaging]="true" style="max-width: 50px; max-height: 180px;" #tblInventoryAssets [allowExcel]="false" [allowFilter]="false" [rawData]="lockLogs" headline="{{'T4.AssetInformation.assetInformationDialog.lblAssetHistory' | translate : 'Asset history' }}" matSort matSortActive="ConfirmedDt" matSortDirection="desc" [autoGenerateColumns]="false" [filterFields]="['TimeStamp', 'Logs']">

          <ng-container matColumnDef="TimeStamp">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="margin-left:20px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 170px; justify-content: left;">{{'T4.AssetInformation.assetInformationDialog.lblTimeStamp' |translate : 'Timestamp' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="margin-left: 20px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 170px; justify-content: left;">{{ row?.TimeStamp | date : 'medium'}}</mat-cell>
          </ng-container>

          <!--
        <ng-container matColumnDef="RentalId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 250px; justify-content: center;">RentalId</mat-header-cell>
          <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 250px; justify-content: center;">{{ row?.RentalId }}</mat-cell>
        </ng-container>
      -->
          <ng-container matColumnDef="Tags">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="margin-left: 20px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 12080px; justify-content: left;">{{'T4.AssetInformation.assetInformationDialog.lblTag' |translate : 'Tag' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="margin-left: 20px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 120px; justify-content: left;"> {{ row?.Tags }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="Logs">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="margin-left: 20px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 250px; justify-content: left;">{{'T4.AssetInformation.assetInformationDialog.lblMessage' |translate : 'Message' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="margin-left: 20px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 250px; justify-content: left;">{{ row?.Logs }}</mat-cell>
          </ng-container>

        </t4-data-table>
      </mat-tab>
      <mat-tab label="{{'T4.AssetInformation.assetInformationDialog.lblhistory' |translate : 'History' }}">
        <t4-entity-event entityId="{{Asset.Id}}" entityType="2"></t4-entity-event>
      </mat-tab>
    </mat-tab-group>

  </t4-container>

</mat-dialog-content>
